﻿import React from "react";
import ReactDOM from 'react-dom';
import PressImagesForm from './pressimagesform';
import PressImages from './pressImages';
import LoadingState from '../../loadingState'

class PressImagesBox extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: null,
            loading: false,
            searchTerm: "",
        }
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchTermChange = this.handleSearchTermChange.bind(this);
    }

    handleSearch(e) {
        this.setState({ loading: true });
        const currentSiteLanguage = document.getElementById("currentsitelanguage").innerText;
        const apiParameters = { siteCulture: currentSiteLanguage, searchTerm: this.state.searchTerm }
        $.ajax({
            type: "POST",
            url: "/press-branding/PressImages/GetPressImagesPartial",
            data: apiParameters
        }).done((result) => {
            this.setState({ data: result, loading: false });
        });
    }

    handleSearchTermChange(e) {
        this.setState({ searchTerm: e.target.value });
    }

    render() {
        // If loadingState is true the display loading component. (bundled with pressImages)
        const loading = this.state.loading ? <LoadingState /> : null;

        return (
            <React.Fragment>
                <div className={"onepcssgrid-1300"}>
                    <PressImagesForm handleSearchTermChange={this.handleSearchTermChange} searchTerm={this.state.searchTerm} handleSearch={this.handleSearch} />
                    <PressImages data={this.state.data}/>             
                </div>
                {loading}
            </React.Fragment>

        );
    }
}

ReactDOM.render(<PressImagesBox />, document.getElementById("pressImages"));